import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { templateApi } from '../utils/studyApiService';
import './TemplateListPage.css';

const TemplateListPage = () => {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [deleteConfirm, setDeleteConfirm] = useState(null); // template id

  const fetchTemplates = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const res = await templateApi.list();
      if (res.success) {
        setTemplates(res.data.items || res.data || []);
      }
    } catch (e) {
      setError(e.message || '템플릿 목록을 불러오지 못했습니다.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTemplates();
  }, [fetchTemplates]);

  const handleDelete = async (id) => {
    try {
      await templateApi.delete(id);
      setTemplates((prev) => prev.filter((t) => t.id !== id));
      setDeleteConfirm(null);
    } catch (e) {
      if (e.code === 'TEMPLATE_IN_USE') {
        alert('이 템플릿으로 작성된 스터디가 있어 삭제할 수 없습니다.');
      } else {
        alert(e.message || '삭제에 실패했습니다.');
      }
      setDeleteConfirm(null);
    }
  };

  return (
    <div className="tpl-list-page">
      <div className="tpl-list-header">
        <h1 className="tpl-list-title">템플릿</h1>
        <button
          className="tpl-list-new-btn"
          onClick={() => navigate('/templates/new')}
        >
          + 템플릿 만들기
        </button>
      </div>

      {error && <div className="tpl-list-error">{error}</div>}

      {loading ? (
        <div className="tpl-list-loading">불러오는 중...</div>
      ) : templates.length === 0 ? (
        <div className="tpl-list-empty">
          <p>아직 템플릿이 없습니다.</p>
          <p className="tpl-list-empty-sub">템플릿을 만들어 스터디 양식을 정의해보세요.</p>
          <button
            className="tpl-list-new-btn"
            onClick={() => navigate('/templates/new')}
          >
            첫 템플릿 만들기
          </button>
        </div>
      ) : (
        <div className="tpl-list-grid">
          {templates.map((tpl) => (
            <div key={tpl.id} className="tpl-card">
              <div
                className="tpl-card-body"
                onClick={() => navigate(`/templates/${tpl.id}/edit`)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && navigate(`/templates/${tpl.id}/edit`)}
              >
                <div className="tpl-card-name">{tpl.name}</div>
                {tpl.description && (
                  <div className="tpl-card-desc">{tpl.description}</div>
                )}
                <div className="tpl-card-meta">
                  <span className="tpl-card-meta-item">
                    필드 {tpl.field_count ?? tpl.schema?.fields?.length ?? 0}개
                  </span>
                  <span className="tpl-card-meta-item">v{tpl.version}</span>
                  {tpl.study_count !== undefined && (
                    <span className="tpl-card-meta-item">
                      스터디 {tpl.study_count}개
                    </span>
                  )}
                </div>
              </div>
              <div className="tpl-card-actions">
                <button
                  className="tpl-card-btn tpl-card-btn-edit"
                  onClick={() => navigate(`/templates/${tpl.id}/edit`)}
                >
                  수정
                </button>
                <button
                  className="tpl-card-btn tpl-card-btn-delete"
                  onClick={() => setDeleteConfirm(tpl.id)}
                >
                  삭제
                </button>
              </div>

              {deleteConfirm === tpl.id && (
                <div className="tpl-delete-confirm">
                  <p>정말 삭제하시겠습니까?</p>
                  <div className="tpl-delete-confirm-btns">
                    <button
                      className="tpl-confirm-btn tpl-confirm-btn-yes"
                      onClick={() => handleDelete(tpl.id)}
                    >
                      삭제
                    </button>
                    <button
                      className="tpl-confirm-btn tpl-confirm-btn-no"
                      onClick={() => setDeleteConfirm(null)}
                    >
                      취소
                    </button>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TemplateListPage;
